module.exports = __webpack_public_path__ + "static/media/icon-resolve-problem.ede22369.svg";